import { connect } from "react-redux";
import { compose, withHandlers, lifecycle } from "recompose";
import { fetchModelsLists } from "../../../redux/reducers/ModelsListReducer";
import { reduxForm, reset } from "redux-form";
import { exportCSVFile, exportCSVModelFile } from "./../../../apis/modelsListAPI/normalizers";

/**
 *
 * @description {get values from store}
 */
export const mapStateToProps = (state) => ({
  modelsListsdata: state.ModelsListReducer.modelsListsdata,
  isFetching: state.ModelsListReducer.isFetchingModels,
});

/**
 *
 * @description {onpage load API calls}
 */
export function componentDidMount() {
  this.props.fetchModelsLists();
}

/**
 *
 * @description {clear form values after submission}
 */
/* istanbul ignore next */
export const afterSubmit = (result, dispatch) =>
  dispatch(reset("ModelReviewForm"));


/**
 *
 * @description {export Model data}
 */
  /* istanbul ignore next */
  export const btnHandler = ({modelsListsdata}) => {
    exportCSVFile(modelsListsdata);
  };
  

export default compose(
  connect(mapStateToProps, { fetchModelsLists }),
  withHandlers({ btnHandler }),
  lifecycle({ componentDidMount }),
  reduxForm({
    form: "ModelReviewForm",
    enableReinitialize: true,
    onSubmitSuccess: afterSubmit,
  })
);
